import { PageHeader } from "@/components/shared/PageHeader";
import { AboutRace } from "@/components/home/AboutRace";
import { WinnersSection } from "@/components/home/WinnersSection";

const IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/i2khs6kh_Novemberka%CC%8Asan%202025-8.webp";

export default function Historia() {
  return (
    <>
      <PageHeader kicker="Arv & Tradition" title="Historia" subtitle="En av världens äldsta endurotävlingar – körd sedan 1915." image={IMG} />
      <AboutRace />
      <WinnersSection />
    </>
  );
}
